class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      select: this.querySelector('select[name="country_code"]'),
    };
    this.elements.select.addEventListener('change', this.submitForm.bind(this));

    // inject flag emoji
    this.querySelectorAll('option').forEach((item) => {
      // eslint-disable-next-line no-param-reassign
      item.innerHTML = `${this.getFlagEmoji(item.value)} ${item.innerHTML}`;
    });
  }

  getFlagEmoji(countryCode) {
    return countryCode.toUpperCase().replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt()));
  }

  submitForm(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);
